<template>
  <div class="flightInfoDetails pl-3">
    <div v-for="(journey, journeyIndex) in journeys" class="journey-details-container mb-2 mt-2" :key="journeyIndex">
      <FlightDetailsInfo :journey="journey" :journey-index="journeyIndex" :key="journeyIndex" />
      
    </div>
    <!-- CO2 Emissions Badge shows a sum of CO2 for the whole flight, including returning and layovers -->
    <FlightCarbonEmissionsBadge :journeys="journeys" class=""></FlightCarbonEmissionsBadge>
  </div>
</template>

<script>

    import FlightCarbonEmissionsBadge from "./FlightCarbonEmissionsBadge";
    import FlightDetailsInfo from "./FlightDetailsInfo";
    import bookingMixin from "@/mixins/bookingMixin";

    export default {
      name: 'FlightDetails',
      mixins: [bookingMixin],
      props: {
        journeys: Array,
      },
      components: {
        FlightCarbonEmissionsBadge,
        FlightDetailsInfo,
      },
      data: function () {
          return {
            multiline: true,
        }
      },
  }

</script>

<style lang="scss" scoped>
  .flightInfoDetails.b-tabs.tab-content{
    padding-top: 0 !important;
  }
</style>
